import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { AUTH_TYPE } from '../../utils/constants';

function Return() {
    const [authType] = useState(useParams().authType);
    const navigate = useNavigate();

    useEffect(() => {
        switch (authType) {
            case AUTH_TYPE.ASSESSMENT:
                navigate('/assessments');
                break;
            case AUTH_TYPE.APP:
                navigate('/apps');
                break;
            default:
                navigate('/');
        }
    });

    return <div>Welcome Back...</div>;
};

export default Return;
